import httpClient from "./httpClient";
import { ILogin } from "../types/ILogin";

const prefix = "/auth";

export async function signIn(credentials: ILogin) {
  return (await httpClient.post(`${prefix}/login`, { ...credentials })).data;
}

export async function signInWithCode(accessCode: string, buildId?: string, notificationToken?: string) {
  return (await httpClient.post(`${prefix}/login-with-code`, { 
    accessCode,
    buildId,
    notificationToken 
  })).data;
}